import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementWorkRequestDocumentTypeAddComponent } from './case-management-work-request-document-type-add.component';

const routes: Routes = [{ path: '', component: CaseManagementWorkRequestDocumentTypeAddComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementWorkRequestDocumentTypeAddRoutingModule { }
